const locale = {
  labelTest: 'FR text'
}

export default locale
